



























































































































































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { Identity } from '@/store/consumer-application/types';
import { requiredRule, characterCountRule, onlyLettersApostrophesHyphensAndSpacesAllowedRule,notDateInFuture } from '@/form-rules';


@Component
export default class IdentityFields extends Vue {
	identity: Identity = this.$store.getters['consumerApplication/consumerApplication'].identity;

	dateOfBirthMenu = false;
	birthDate = this.formatDate(this.identity.dateOfBirth);

	data() {
		return {
			show: false,
			firstNameRules: [
				requiredRule('First Name is required'),
				characterCountRule('First Name', 20),
				onlyLettersApostrophesHyphensAndSpacesAllowedRule(),
			],
			lastNameRules: [
				requiredRule('Last Name is required'),
				characterCountRule('Last Name', 20),
				onlyLettersApostrophesHyphensAndSpacesAllowedRule(),
			],
			nameOnCardRules: [
				characterCountRule('Name on Card', 40),
				onlyLettersApostrophesHyphensAndSpacesAllowedRule(),
			],
			birthDateRules: [
				requiredRule('Birth Date is required'),
				notDateInFuture(),
			],
			taxIdRules: [
				requiredRule('Social Security Number is required'),
			],
		};
	}
	updateIdentity () {
		this.$store.commit('consumerApplication/SET_IDENTITY_FIELDS', this.identity, { root: true });
	}

	formatDate (date: string | undefined) {
		if (!date) return ''
		const [year, month, day] = date.split('-')
		return `${month}/${day}/${year}`
	}

	parseDate (date: string | undefined) {
		if (!date) return ''
		const [month, day, year] = date.split('/')
		return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
	}
}
